"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayrollModel = /** @class */ (function () {
    function PayrollModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/payroll",
            UPDATE: APPURL + "/api/v1/payroll",
            CREATE: APPURL + "/api/v1/payroll",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    PayrollModel.prototype.extract = function (result) {
        return result.data;
    };
    PayrollModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    PayrollModel.prototype.getByID = function (id) {
        return this.$http.get(this.URLS.FETCH + "/" + id).then(this.cacheResults);
    };
    PayrollModel.prototype.get = function () {
        return this.$http.get(this.URLS.FETCH).then(this.cacheResults);
    };
    PayrollModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    PayrollModel.prototype.updateCollection = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/6/collection", request)
            .then(this.cacheResults);
    };
    PayrollModel.prototype.runPayroll = function (request) {
        return this.$http.post(this.URLS.FETCH, request).then(this.cacheResults);
    };
    PayrollModel.prototype.insert = function (request) {
        return this.$http.post(this.URLS.FETCH, request).then(this.cacheResults);
    };
    PayrollModel.prototype.remove = function (user) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + user.id)
            .then(this.cacheResults);
    };
    return PayrollModel;
}());
PayrollModel.$inject = ["$http", "APPURL"];
exports.default = PayrollModel;
